import { styled } from '@mui/material/styles';

export const SomeAllowed = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(2),
  cursor: 'pointer',
  // doesn't match Typography 🤷
  textDecorationLine: 'underline',
  color: 'rgba(0, 0, 0, 0.38)',
}));
